import axiosInstance from "@/lib/axios";

export const shopService = {
  getShops: async (params = {}) => {
    
    const response = await axiosInstance.get('/api/v1/admin/shops', { params });
    return response.data;
  },

  getShopDetails: async (id) => {
    const response =await axiosInstance.get(`/api/v1/admin/shops/${id}`);
    return response.data;
  },
  
  toggleShopStatus: async (id) => {
    const response = await axiosInstance.put(`/api/v1/admin/shops/${id}/toggle-status`);
    return response.data;
  },
  
  toggleShopVerification: async (id) => {
    const response = await axiosInstance.put(`/api/v1/admin/shops/${id}/toggle-verification`);
    return response.data;
  }
};
